import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            position: 'relative',
            mx: 'auto',
            px: {base: remCalc(16), md: remCalc(24), lg: 0},
            maxWidth: {base: '100%', lg: remCalc(1400)},
            textAlign: 'center',
            gap: {base: remCalc(16), sm: remCalc(24), md: remCalc(40)},
        },
        textblock: {
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        heading: {},
        bodycopy: {
            textStyle: 'body-large',
        },
        medias: {
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        wideMedia: {
            w: '100%',
            maxW: {base: remCalc(343), sm: remCalc(598), md: remCalc(810), lg: remCalc(1400)},
        },
        halfMedia: {
            w: '100%',
            maxW: {base: remCalc(343), sm: remCalc(290), md: remCalc(393), lg: remCalc(688)},
        },
    },
}
